<script>  
  export default {
    props: {
      fornecedor: {
        type: Object,
        required: true,
      }
    },
    methods: {
      validar(valido) {

        if (!valido) throw new Error("validacao com erro");

        return this.$validator.validateAll();
      },
    }
  }
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-4 col-md-4 col-sm-12">
        <div class="form-group">
          <label class="control-label" for="telefone-residencial">Tel. residencial</label>

          <input type="text"
                 class="form-control"
                 id="telefone-residencial"
                 v-mascara="'telefone'"
                 v-model="fornecedor.telefone1"
                 >
        </div>
      </div>

      <div class="col-lg-4 col-md-4 col-sm-12">
        <div class="form-group required" :class="{'has-error': errors.has('telefone2')}">
          <label class="control-label" for="telefone-comercial">Tel. comercial</label>

          <input id="telefone-comercial"
                 class="form-control"
                 type="text"
                 v-mascara="'telefone'"
                 v-model="fornecedor.telefone2"
                 data-vv-name="telefone2"
                 data-vv-as="Tel. comercial"
                 v-validate="'required'">

          <p class="text-danger" v-show="errors.has('telefone2')">{{ errors.first('telefone2') }}</p>
        </div>
      </div>

      <div class="col-lg-4 col-md-4 col-sm-12">
        <div class="form-group">
          <label class="control-label" for="fax">Fax</label>

          <input id="fax"
                 class="form-control"
                 type="text"
                 v-mascara="'telefone'"
                 v-model="fornecedor.fax">
        </div>
      </div>
    </div>

    <div class="hr-line-dashed margin-top-5">Financeiro</div>
    <h4 class="mb-3">Contato financeiro</h4>

    <div class="row">
      <div class="col-lg-4 col-md-12 col-sm-12">
        <div class="form-group">
          <label class="control-label" for="contato">Nome do contato</label>

          <input type="text"
                 class="form-control"
                 id="contato"
                 v-model="fornecedor.contato"
                 maxlength="60">
        </div>
      </div>

      <div class="col-lg-4 col-md-6 col-sm-12">
        <div class="form-group">
          <label class="control-label" for="cargo-financeiro">Cargo do contato</label>

          <input type="text"
                 class="form-control"
                 id="cargo-financeiro"
                 v-model="fornecedor.cargoFinanceiro"
                 maxlength="40">
        </div>
      </div>

      <div class="col-lg-4 col-md-6 col-sm-12">
        <div class="form-group">
          <label class="control-label" for="tel-contato-financeiro">Tel. do financeiro</label>

          <input id="tel-contato-financeiro"
                 class="form-control"
                 type="text"
                 v-mascara="'telefone'"
                 v-model="fornecedor.telContatoFinanceiro">
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group required" :class="{'has-error': errors.has('email')}">
          <label class="control-label" for="email">E-mail do financeiro</label>

          <input type="text"
                 class="form-control"
                 id="email"
                 v-model="fornecedor.email"
                 data-vv-as="e-mail financeiro"
                 data-vv-name="email"
                 v-validate="'required|email'"
                 maxlength="300">

          <p class="text-danger" v-show="errors.has('email')">{{ errors.first('email') }}</p>
        </div>
      </div>
    </div>

    <div class="hr-line-dashed margin-top-5"></div>
    <h4 class="mb-3"><b>Contato de compras / Pesquisa de preço</b></h4>

    <div class="row">
      <div class="col-lg-4 col-md-12 col-sm-12">
        <div class="form-group">
          <label class="control-label" for="contato-compras">Nome do contato</label>

          <input type="text"
                 class="form-control"
                 id="contato-compras"
                 v-model="fornecedor.contatoCompras"
                 maxlength="60">
        </div>
      </div>

      <div class="col-lg-4 col-md-6 col-sm-12">
        <div class="form-group">
          <label class="control-label" for="cargo-compras">Cargo do contato</label>

          <input type="text"
                 class="form-control"
                 id="cargo-compras"
                 v-model="fornecedor.cargoCompras"
                 maxlength="40">
        </div>
      </div>

      <div class="col-lg-4 col-md-6 col-sm-12">
        <div class="form-group">
          <label class="control-label" for="tel-contato-compras">Tel. de compras</label>

          <input id="tel-contato-compras"
                 class="form-control"
                 type="text"
                 v-mascara="'telefone'"
                 v-model="fornecedor.telContatoCompras">
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6">
        <div class="form-group required" :class="{'has-error': errors.has('emailPesquisa')}">
          <label class="control-label" for="email">E-mail para pesquisa de preço</label>

          <input type="text"
                 class="form-control"
                 id="email-pesquisa"
                 v-model="fornecedor.emailPesquisa"
                 data-vv-as="E-mail pesquisa de preço"
                 data-vv-name="emailPesquisa"
                 v-validate="'required|email'"
                 maxlength="300">

          <p class="text-danger" v-show="errors.has('emailPesquisa')">{{ errors.first('emailPesquisa') }}</p>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="form-group required" :class="{'has-error': errors.has('emailCompras')}">
          <label class="control-label" for="email">E-mail para pedido de compras</label>

          <input type="text"
                 class="form-control"
                 id="email-compras"
                 v-model="fornecedor.emailCompras"
                 data-vv-as="E-mail pedido de compras"
                 data-vv-name="emailCompras"
                 v-validate="'required|email'"
                 maxlength="300">

          <p class="text-danger" v-show="errors.has('emailCompras')">{{ errors.first('emailCompras') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/web-fornecedor/componentes/compartilhado/FormDadosContatos.vue